export default function Footer() {
    return (
        <footer>
            <p>Happy Place</p>
                <address>
                    Contact us at  <a href="tel:425-123-4567">(425)-123-4567</a>
                </address>
                <p>&copy; INFO 442 Fall 2022</p>
        </footer>
    )
}